"use strict";

module.exports = function () {
  this.page = 1;

  if (!this.opts.pagination.dropdown) {
    this.$refs.pagination.setPage(1);
  }
};


//////////////////
// WEBPACK FOOTER
// ./~/vue-tables-2/compiled/methods/init-pagination.js
// module id = 1603
// module chunks = 64